<a
    *ngIf="validPhoneNumber"
    [href]="link"
    target="_blank"
    class="pill pill--telephone">
    <i class="uil uil-whatsapp"></i>
    Whatsapp
</a>
